import React, { useState } from 'react'
import './Search.css'
import Search from '@material-ui/icons/Search'
import ArrowDropDown from '@material-ui/icons/ArrowDropDown'
import ArrowDropUp from '@material-ui/icons/ArrowDropUp'

const LocalSearch = (props) => {

    const [show, setShow] = useState(true)

    const handleShow = (event) => {
        show == true ? setShow(false) : setShow(true)
    }
    const searchClass = show == true ? "SearchFadeIn" : "SearchFadeOut"
    const headerClass = show == true ? "SearchHeader" : "SearchHeaderClose"
    return (
        <div className="row justify-content-center w-100 ml-0 mr-0 mt-4">
            <div className={[headerClass, props.class].join(' ')}>
                <Search className="Icon" />
                <span className="search-text">جستجو</span>
                {show == true ?
                    <span onClick={handleShow} className="IconLeft" ><ArrowDropDown /></span>
                    :
                    <span onClick={handleShow} className="IconLeft" ><ArrowDropUp /></span>}
            </div>
            <div className={["Form", searchClass, props.class].join(' ')}>
                {props.form}
            </div>
        </div>
    )
}

export default LocalSearch